import React from 'react';
import GameQuery from '../../query/GameQuery';
import IncomeStatement from '../../components/IncomeStatement';
import { Route } from 'react-router-dom';
import { INCOMESTATEMENT } from '../../routes';

const IncomeStatementRoute = () => (
	<GameQuery>
		{({ game }) => (
			<Route
				path={INCOMESTATEMENT}
				render={props => <IncomeStatement {...props} game={game} />}
			/>
		)}
	</GameQuery>
);

export default IncomeStatementRoute;
